import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DfxIcon, IconColor, StyledLink } from '@dfx.swiss/react-components';
import { useNavigation } from '../hooks/navigation.hook';
import { isAbsoluteUrl } from '../util/utils';
export function NavigationLink({ icon, label, url, target }) {
    const { navigate } = useNavigation();
    const actionProp = url && (isAbsoluteUrl(url) ? { url } : { onClick: () => navigate(url) });
    return (_jsxs("div", Object.assign({ className: "flex flex-row items-center space-x-2" }, { children: [_jsx(DfxIcon, { icon: icon, color: IconColor.RED }), _jsx(StyledLink, Object.assign({ label: label }, actionProp, { target: target, dark: true }))] })));
}
